import { Helmet } from "react-helmet-async";

const GlobalStructuredData = () => {
  const localBusiness = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    name: "Processing Bros",
    url: "https://processingbros.com",
    telephone: "+1-954-399-2230",
    image: "https://processingbros.com/processing-bros-icon-ios.png",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Fort Lauderdale",
      addressRegion: "FL",
      addressCountry: "US",
    },
    areaServed: [
      {
        "@type": "AdministrativeArea",
        name: "Fort Lauderdale, FL",
      },
      {
        "@type": "AdministrativeArea", 
        name: "Broward County, FL",
      },
      {
        "@type": "AdministrativeArea",
        name: "Miami-Dade County, FL",
      },
      {
        "@type": "AdministrativeArea",
        name: "Palm Beach County, FL",
      }
    ],
    sameAs: [],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        opens: "09:00",
        closes: "18:00",
      },
    ],
    priceRange: "$$",
    foundingDate: "2023-01-01",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: 4.9,
      reviewCount: 120,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(localBusiness)}</script>
    </Helmet>
  );
};

export default GlobalStructuredData;
